"use client";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as AccessibleIcon from "@radix-ui/react-accessible-icon";
export default function Icon({ title, label, width = 24, height = 24, ...props }) {
    if (!label) {
        return (_jsxs("svg", { viewBox: "0 0 24 24", width: width, height: height, ...props, children: [title && _jsx("title", { children: title }), props.children] }));
    }
    return (_jsx(AccessibleIcon.Root, { label: label, children: _jsxs("svg", { viewBox: "0 0 24 24", width: width, height: height, ...props, children: [title && _jsx("title", { children: title }), props.children] }) }));
}
